exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SendCode {\n  width: 70%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; }\n  .SendCode__Resend {\n    margin-right: 10px; }\n  .SendCode__Buttons {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center; }\n  .SendCode__Button {\n    width: 100px; }\n  .SendCode__ResendInfo {\n    margin: 20px 0; }\n", ""]);

// exports
